import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                // menu: {
                //     route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), '')}.home`,
                //     text: 'Home',
                //     icon: 'fas fa-home',
                // },
                acl: {
                    view: 'GEOAPI_00013',
                },
            },
            settings: {
                menu: {
                    route: `${code}.settings`,
                    text: 'Configurações',
                    icon: 'fas fa-cogs',
                },
                acl: {
                    view                    : 'GEOAPI_00021',
                    edit                    : 'GEOAPI_00022',
                },
                url: {
                    getConfig               : `/${codeAPI}/gestao/definitions`,
                },
            },
            layers: {
                menu: {
                    route: `${code}.layers`,
                    text: "layers.titles",
                    icon: "fas fa-layer-group",
                },
                acl: {
                    view                    : 'GEOAPI_00017',
                    detail                  : 'GEOAPI_00016',
                    add                     : 'GEOAPI_00014',
                    edit                    : 'GEOAPI_00015',
                    delete                  : 'GEOAPI_00018',
                    private                 : 'GEOAPI_00003',
                },
                url: {
                    getList: `${codeAPI}/gestao/layers`,
                    getShow: `${codeAPI}/gestao/layers/:id`,
                    getCreate: `${codeAPI}/gestao/layers`,
                    getUpdate: `${codeAPI}/gestao/layers/:id`,
                    getDelete: `${codeAPI}/gestao/layers/:id`,
                    getLists: `${codeAPI}/gestao/layers/lists`,
                    getResources: `${codeAPI}/gestao/layers/resources`,
                    describeResource: `${codeAPI}/gestao/layers/resources/:id/describe`,
                },
            },
        },
        tools: {

        }
    },
};

export default state;